export { default } from "./permitted";
